import http from "../utils/http-common";

const get = (id: number) => {
  return http.get(`/group/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/group/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/group/${id}`);
};
const post = (data: any) => {
  return http.post(`/group`, data);
};
const getAll = () => {
  return http.get(`/group`);
};
export const groupService = {
  get,
  put,
  remove,
  post,
  getAll,
};

export default groupService;
